<template>
<w-map-popup :titleVisible="false">
  <div :class="$style.main">
    <div :class="$style.header" class="minimap-popup-header">
      <i :class="$style.close" class="map-align-close-btn" @click="onCloseClick"></i>
    </div>
    <div :class="$style.view">
      <w-map-button icon="btn_frontmost" tooltipPlacement="right" tooltip="맨 앞으로 가져오기" @onClick="sendToTop"></w-map-button>
      <w-map-button icon="btn_backmost" tooltipPlacement="right" tooltip="맨 뒤로 보내기" @onClick="sendToBottom"></w-map-button>
      <w-map-button icon="btn_front" tooltipPlacement="right" tooltip="앞으로 가져오기" @onClick="sendForward"></w-map-button>
      <w-map-button icon="btn_back" tooltipPlacement="right" tooltip="뒤로 보내기" @onClick="sendBackward"></w-map-button>
      <div class="map-align-btn-split"></div>
      <w-map-button icon="btn_left" tooltipPlacement="right" tooltip="왼쪽 맞춤" @onClick="alignLeft"></w-map-button>
      <w-map-button icon="btn_center" tooltipPlacement="right" tooltip="가운데 맞춤" @onClick="alignCenter"></w-map-button>
      <w-map-button icon="btn_right" tooltipPlacement="right" tooltip="오른쪽 맞춤" @onClick="alignRight"></w-map-button>
      <w-map-button icon="btn_top" tooltipPlacement="right" tooltip="위쪽 맞춤" @onClick="alignTop"></w-map-button>
      <w-map-button icon="btn_middle" tooltipPlacement="right" tooltip="중간 맞춤" @onClick="alignMiddle"></w-map-button>
      <w-map-button icon="btn_bottom" tooltipPlacement="right" tooltip="아래쪽 맞춤" @onClick="alignBottom"></w-map-button>
      <div class="map-align-btn-split"></div>
      <w-map-button icon="btn_interval_column" tooltipPlacement="right" tooltip="가로 간격을 동일하게" @onClick="distributeHorizontally"></w-map-button>
      <w-map-button icon="btn_interval_row" tooltipPlacement="right" tooltip="세로 간격을 동일하게" @onClick="distributeVertically"></w-map-button>
    </div>
  </div>
</w-map-popup>
</template>

<script>
import MapConst from '@/constants/topologymap';

import WMapPopup from '@/views/topologymap/components/MapPopup';
import WMapButton from '@/views/topologymap/components/MapButton';
import { Q, MapInfo, MapPopup } from '@/views/topologymap/js/maps';

export default {
  name: 'WAlignToolWindow',
  components: {
    WMapPopup,
    WMapButton,
  },
  data() {
    return {
      MapConst,
      /**
       * 팝업 속성
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        x: window.innerWidth - 70,
        y: 95,
        width: 54,
        height: 485,
        clickToClose: false,
        scrollable: false,
        resizable: false,
        draggable: '.minimap-popup-header',
      },
    };
  },
  methods: {
    /**
     * 맨 앞으로 가져오기
     */
    sendToTop() {
      const graph = MapInfo.getInstance(this).getGraph();
      const gm = graph.graphModel;
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      let maxZIndex = Math.max.apply(null, gm.toDatas().map((o) => o.zIndex || 0));

      sm.forEach((model) => {
        model.set('z', (maxZIndex += 1));
      });

      graph.invalidate();
    },
    /**
     * 맨 뒤로 보내기
     */
    sendToBottom() {
      const graph = MapInfo.getInstance(this).getGraph();
      const gm = graph.graphModel;
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      let minZIndex = Math.min.apply(null, gm.toDatas().map((o) => o.zIndex || 0));

      sm.forEach((model) => {
        model.set('z', (minZIndex -= 1));
      });

      graph.invalidate();
    },
    /**
     * 앞으로 가져오기
     */
    sendForward() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      sm.forEach((model) => {
        model.set('z', parseInt(model.get('z'), 10) + 1);
      });

      graph.invalidate();
    },
    /**
     * 뒤로 보내기
     */
    sendBackward() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      sm.forEach((model) => {
        model.set('z', parseInt(model.get('z'), 10) - 1);
      });

      graph.invalidate();
    },
    /**
     * 왼쪽 맞춤
     */
    alignLeft() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const x = Math.min.apply(null, sm.map((o) => (o.x - (o.size.width / 2)) || 0));

      sm.forEach((model) => {
        model.x = x + (model.size.width / 2);
      });

      graph.invalidate();
    },
    /**
     * 가운데 맞춤
     */
    alignCenter() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const lx = Math.min.apply(null, sm.map((o) => o.x || 0));
      const rx = Math.max.apply(null, sm.map((o) => o.x || 0));
      const cx = (lx + rx) / 2;

      sm.forEach((model) => {
        model.x = cx;
      });

      graph.invalidate();
    },
    /**
     * 오른쪽 맞춤
     */
    alignRight() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const x = Math.max.apply(null, sm.map((o) => (o.x + (o.size.width / 2)) || 0));

      sm.forEach((model) => {
        model.x = x - (model.size.width / 2);
      });

      graph.invalidate();
    },
    /**
     * 위쪽 맞춤
     */
    alignTop() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const y = Math.min.apply(null, sm.map((o) => (o.y - (o.size.height / 2)) || 0));

      sm.forEach((model) => {
        model.y = y + (model.size.height / 2);
      });

      graph.invalidate();
    },
    /**
     * 중간 맞춤
     */
    alignMiddle() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const ty = Math.min.apply(null, sm.map((o) => o.y || 0));
      const by = Math.max.apply(null, sm.map((o) => o.y || 0));
      const my = (ty + by) / 2;

      sm.forEach((model) => {
        model.y = my;
      });

      graph.invalidate();
    },
    /**
     * 아래쪽 맞춤
     */
    alignBottom() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const y = Math.max.apply(null, sm.map((o) => (o.y + (o.size.height / 2)) || 0));

      sm.forEach((model) => {
        model.y = y - (model.size.height / 2);
      });

      graph.invalidate();
    },
    /**
     * 가로 간격을 동일하게
     */
    distributeHorizontally() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const lx = Math.min.apply(null, sm.map((o) => o.x || 0));
      const rx = Math.max.apply(null, sm.map((o) => o.x || 0));
      const ax = (rx - lx) / (sm.length - 1);

      sm.sort((a, b) => a.x - b.x);

      sm.forEach((model, index) => {
        model.x = lx + (ax * index);
      });

      graph.invalidate();
    },
    /**
     * 세로 간격을 동일하게
     */
    distributeVertically() {
      const graph = MapInfo.getInstance(this).getGraph();
      const sm = MapInfo.getInstance(this).getAlignTargetModel();

      const ty = Math.min.apply(null, sm.map((o) => o.y || 0));
      const by = Math.max.apply(null, sm.map((o) => o.y || 0));
      const ay = (by - ty) / (sm.length - 1);

      sm.sort((a, b) => a.y - b.y);

      sm.forEach((model, index) => {
        model.y = ty + (ay * index);
      });

      graph.invalidate();
    },
    /**
     * 닫기 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onCloseClick() {
      MapPopup.closeAndHide(this.$options.name);
    },
  },
};
</script>

<style module>
.main {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 5px 7px;
}

.header {
  position: absolute;
  background-color: #5b739f;
  border-bottom: 2px solid #4d648f;
  height: 18px;
  width: 100%;
  top: 0;
  left: 0;
  cursor: move;
}

.view {
  width: 100%;
  height: 100%;
  padding-top: 18px;
}

.close {
  float: right;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/edit/AlignToolWindow.vue